<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="用户">
            <Input v-model="form.cardNo"></Input>
          </FormItem>
          <FormItem label="用户账号">
            <Input v-model="form.bankCardNo"></Input>
          </FormItem>
          <FormItem label="账户类型">
            <Dict v-model="form.billType" dict="bill_type" needAll="true"></Dict>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <tradeuploadInfo ref="tradeuploadInfoRef" @handle-search="handleSearch"></tradeuploadInfo>
  </div>
</template>

<script>
import tradeuploadInfo from './tradeupload-info'
import { getIds } from '@/libs/util'
import { download } from '@/libs/api.request'

export default {
  name: 'tradeupload-list',
  components: {
    tradeuploadInfo
  },
  data () {
    return {
      columns: [
        {
          title: '客户',
          key: 'customId',
          render: (h, params) => {
            return h('span', this.getCustomName(params.row.customId))
          }
        },
        {
          title: '账单类型',
          key: 'billType',
          render: (h, params) => {
            return h('span', this.getDictVal('bill_type', params.row.billType))
          }
        },
        { title: '用户账号', key: 'bankCardNo' },
        { title: '账单姓名', key: 'name' },
        { title: '文件名', key: 'fileName' },
        { title: '总金额', key: 'money' },
        { title: '上传时间', key: 'uploadTime' },
        { title: '账单开始时间', key: 'startTime' },
        { title: '账单结束时间', key: 'endTime' },
        { title: '电子签', key: 'signNums' },
        { title: '余额连续性', key: 'continuity' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['detail'],
          button: [
            (h, params, vm) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'md-attach'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.downFile(params.row.tradeNo)
                  }
                }
              }, '文件下载')
            }]
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.tradeuploadInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.tradeuploadInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.tradeuploadInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('tradeupload', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    downFile (fileId) {
      download('api/tradeUploadErrorltd/getFile', { fileId: fileId })
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('tradeuploadltd', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
